export default class GameSoundVars {
    public static "GAME_START" = "game_start";
    public static "IDLE_MUSIC" = "idleBackgroundMusic";
    public static "BIG_WIN" = "big_win";
    public static "BIG_WIN_COINS" = "big_win_coins";
    // public static "PICKSCREEN_INTRO" = "pickscreen_intro";
    // public static "PICKSCREEN_LOOP" = "pickscreen_loop";
    // public static "PICKSCREEN_OUTRO" = "pickscreen_outro";
    // public static "PICKSCREEN_HOVER" = "pickscreen_hover";
    // public static "PICKSCREEN_CLICK" = "pickscreen_click";
    public static "FREE_SPINS_COMPLETED" = "free_spins_completed";
    public static "REEL_ANTICIPATION_NO_WIN" = "reel_anticipation_no_win";
    public static "FREE_SPINS_INTRO" = "free_spins_intro";
}